import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LoginRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (sessionStorage.getItem('bbx-token')) {
      this.router.navigateByUrl('/shipment-list');
      return false;
    } else {
      return true;
    }
  }
}
